import { useEffect } from "react";

interface StructuredDataProps {
  id: string;
  data: Record<string, unknown>;
}

export function StructuredData({ id, data }: StructuredDataProps) {
  useEffect(() => {
    document
      .querySelectorAll('script[type="application/ld+json"]:not([id^="structured-data-"])')
      .forEach((element) => element.remove());
  }, []);

  return (
    <script
      id={`structured-data-${id}`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
